import React, { useEffect, useState } from "react";
import "../../styles/styles.css";
import "../../styles/layout.css";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import LeaveViewController from "../../redux/actions/leaveApiAction";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register the chart components
ChartJS.register(ArcElement, Tooltip, Legend);

const LeaveBalanceChart = () => {
  const dispatch = useDispatch();
  const { getLeaveBalance  } = LeaveViewController();
  const { leaveBalance } = useSelector((state) => state.leave);

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    dispatch(getLeaveBalance ());
  }, []);

  

  const generateLeaveYears = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2020; // or any logical lower limit
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  };

  // Create chart data based on the leave balance
  const selectedBalance = leaveBalance?.find(
    (balance) => Number(balance.leave_year) === Number(selectedYear)
  );
  

  const generatePieChartData = () => {
    const paid = selectedBalance?.remaining_paid_leave_balance || 0;
    const unpaid = selectedBalance?.remaining_unpaid_leave_balance || 0;
    const carry = selectedBalance?.carry_forward_days || 0;

    return {
      labels: ["Paid Leave", "Unpaid Leave", "Carry Forward"],
      datasets: [
        {
          data: [paid, unpaid, carry],
          backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
        },
      ],
    };
  };

  return (
    <div>
       
      {/* Top right dropdown */}
      <div className="d-flex justify-content-end align-items-center mb-2">
        <Form.Group controlId="yearSelect" className="d-flex align-items-center">
          <Form.Label className="me-2 fw-bold mb-0">Select Year:</Form.Label>
          <Form.Select
            size="sm"
            value={selectedYear}
            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
            style={{ width: '150px'}}
          >
            {generateLeaveYears().map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </div>
        
          <Row className="mt-2">
                 <Col>
                   <div className="card d-flex d-flex-direction-row align-items-center"
                   style={{ background: 'linear-gradient(135deg, #a18cd1 , #fbc2eb )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}
                    >
                     <div className="d-flex d-flex-direction-column">
                       <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} >
                         PAID LEAVES
                       </h6>
                       <h3 className="value m-0">
                        <span style={{ color: '#d9d9d9' }}>
                        {selectedBalance?.remaining_paid_leave_balance || 0}
                       </span>/
                      {selectedBalance?.paid_leave_balance || 0}</h3>
                     </div>
                   </div>
                 </Col>
                 <Col>
                   <div className="card d-flex d-flex-direction-row align-items-center"
                   style={{ background: 'linear-gradient(135deg, #007bff , #cce5ff )', padding: '16px', borderRadius: '8px', height: '100px',width: '100%'}}
                   >
                     <div className="d-flex d-flex-direction-column">
                       <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}}> UNPAID LEAVES</h6>
                       <h3 className="value mb-0">
                        <span style={{ color: '#d9d9d9' }}>
                          {selectedBalance?.remaining_unpaid_leave_balance || 0}
                          </span>/
                          {selectedBalance?.unpaid_leave_balance || 0}</h3>
                     </div>
                   </div>
                 </Col>
                 <Col>
                   <div className="card d-flex d-flex-direction-row align-items-center" 
                   style={{ background: 'linear-gradient(135deg, #357e46 , #d4edda )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}>
                     <div className="d-flex d-flex-direction-column">
                       <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} >CARRY FORWORD LEAVES</h6>
                       <h3 className="value mb-0">
                        <span style={{ color: '#d9d9d9' }}>
                        {selectedBalance?.carry_forward_days || 0}
                        </span>/
                        {selectedBalance?.carry_forward_days || 0}</h3>
                     </div>
                   </div>
                 </Col>
                 <Col>
                   <div className="card d-flex d-flex-direction-row align-items-center" 
                   style={{ background: 'linear-gradient(135deg, #c32230 , #f8d7da )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}>
                     <div className="d-flex d-flex-direction-column">
                       <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} > TOTAL LEAVES</h6>
                       <h3 className="value mb-0">{selectedBalance?.total_leave_balance || 0}</h3>
                     </div>
                   </div>
                 </Col>
                 <Col>
                   <div className="card d-flex d-flex-direction-row align-items-center"
                   style={{background: 'linear-gradient(135deg, #55585e , #e2e3e5 )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}>
                     <div className="d-flex d-flex-direction-column">
                       <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} > REMANING LEAVES </h6>
                       <h3 className="value mb-0">{selectedBalance?.remaining_total_leave_balance || 0}</h3>
                     </div>
                   </div>
                 </Col>
                
               </Row>
        
          {/* Render the Pie chart for Employee */}
          <div  style={{ height: '80vh', paddingLeft: '0%' }}>
            <div className="d-flex flex-wrap" style={{ gap: '50px', alignItems: 'center' }}>
              {/* Pie Chart */}
              <div style={{ width: '300px', height: '300px' }}>
              <Pie
                  data={generatePieChartData()}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: false,
                      },
                      // Custom Plugin to render text in center
                      centerText: {
                        display: true,
                        text: ` Remaning Leaves : ${ (selectedBalance?.remaining_total_leave_balance || 0)}`
                      }
                    },
                    cutout: '80%',
                  }}
                  plugins={[{
                    id: 'centerText',
                    beforeDraw: (chart) => {
                      const { width } = chart;
                      const { height } = chart;
                      const ctx = chart.ctx;
                      ctx.restore();
                      const fontSize = 18;
                      ctx.font = `${fontSize}px Arial`;
                      ctx.textBaseline = "middle";

                      const text = chart.options.plugins.centerText.text;
                      const textX = Math.round((width - ctx.measureText(text).width) / 2);
                      const textY = height / 2;

                      ctx.fillText(text, textX, textY);
                      ctx.save();
                    }
                  }]}
                />
              </div>
              {/* Custom Legend */}
              <div>
                <h5>Legend</h5>
                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                  <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '15px', height: '15px', backgroundColor: '#4caf50', marginRight: '20px' }}></div>  Remaning Paid Leave
                  </li>
                  <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '15px', height: '15px', backgroundColor: '#f44336', marginRight: '20px' }}></div> Remaning Unpaid Leave
                  </li>
                  <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '15px', height: '15px', backgroundColor: '#ff9800', marginRight: '20px' }}></div> Remaning Carry Forward
                  </li>
                </ul>
              </div>
            </div>
          </div>     
    </div>
  );
};

export default LeaveBalanceChart;


















